// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings__react-hint{width:264px;height:fit-content;position:absolute;background:#fff;box-shadow:0px -2px 10px rgba(44,40,40,.02),0px 0px 4px rgba(44,40,40,.04),0px 4px 8px rgba(44,40,40,.06);border-radius:16px;padding:10px;z-index:10}", ""]);
// Exports
module.exports = exports;
